import React from "react";
import styled from "styled-components";
import {InputsContainer} from "./radioStyles";
import {Field} from "formik";

const StateObjectiveOrIndicatorInput = ({value}) => {
    return (
        <RadioButtonsContainer>
            <div>
                <InputsContainer>
                    <label>
                        <Field
                            name="onGoing"
                            type={"radio"}
                            value={"true"}
                            checked={value.toString() === "true"}
                        />
                        <div><p> Non-atteint</p></div>
                    </label>

                </InputsContainer>

            </div>
            <div>
                <InputsContainer>
                    <label>
                        <Field
                            name="onGoing"
                            type={"radio"}
                            value={"false"}
                            checked={value.toString() === "false"}
                        />
                        <div><p> Atteint </p></div>
                    </label>

                </InputsContainer>
            </div>

        </RadioButtonsContainer>

    )
}

const RadioButtonsContainer = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
`


export default StateObjectiveOrIndicatorInput;